"use client";

import { useEffect, useRef, useState } from "react";
import Image from "next/image";
import { formatDistanceToNow } from "date-fns";
import DOMPurify from 'dompurify';
import styles from './NotificationPopup.module.css';
import { NotificationMessage } from "@/models/notification";
import { AppDispatch, useAppSelector } from "@/redux/store";
import { fetchNotifications, markAllAsRead, setNotifications } from "@/redux/features/notification-slice";
import { useDispatch } from "react-redux";
import { get } from "lodash";
import { getAllNotifications } from "@/helpers/server-actions/notification-collection";

type NotificationPopupProps = {
    notificationss?: Notification[];
    onClose: () => void;
}


export default function NotificationPopup({ onClose, notificationss = [] }: NotificationPopupProps) {

    const notifications = useAppSelector((state) => state.notificationReducer.notifications);
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        dispatch(fetchNotifications());
    }, [dispatch]);


    return (
        <div className="notification-popup absolute top-6 md:left-0 left-1/2 md:transform-none transform -translate-x-1/2 min-w-[385px] bg-white text-[var(--Neutrals-Secondary-Dark-Neutral---Thunder)]" style={{ borderRadius: '20px', zIndex: 1000 }}>
            <div className="w-[385px] bg-white rounded-t-xl flex flex-col justify-start items-start" style={{ borderRadius: '20px', boxShadow: '0px 2px 10px 0px rgba(0,0,0,0.10)' }}>
                <div className="flex justify-between w-full py-4" style={{ borderBottom: '1px #C4C4C4 solid' }}>

                    <span className="px-5 text-sm font-medium">
                        Notifications
                    </span>

                    <span
                        onClick={() => {
                            dispatch(markAllAsRead());
                        }}
                        className="pr-5 text-sm font-semibold">
                        Mark all as read
                    </span>
                </div>
                <div

                    className={`max-h-[590px] overflow-y-auto w-full ${styles.customScrollbar} mb-4`}>
                    {
                        notifications.length === 0 && (
                            <div className="w-full items-center py-4 px-5">
                                <span className="text-sm">You have no notificatons yet</span>
                            </div>
                        )
                    }

                    {
                        notifications.length > 0 && notifications.map((notification, index) => (
                            <NotificationWidget key={notification.id} notification={notification} />
                        ))
                    }
                </div>
            </div >
        </div >
    );
}

export function NotificationWidget({ notification }: { notification: NotificationMessage }) {
    const [bgColor, setBgColor] = useState<string>('bg-[var(--Neutrals-Main-Neutral---Limed-Spruce)]');
    return <div
        onClick={() => {
            if (notification.link) {
                window.location.href = notification.link;
            }


        }}
        className="w-full flex flex-row justify-start items-center px-2 pt-4 cursor-pointer hover:bg-[var(--Neutrals-Main-Neutral---Limed-Spruce-0-10-Opacity)]">

        <div className="mr-2 flex flex-shrink-0">
            {!notification.isRead ? (
                <Image src="/icons/unread-notification.svg" alt="icon" width={5} height={5} />
            ) :
                (
                    <div className="w-[5px]">

                    </div>
                )}
        </div>

        <div className={`rounded-full w-10 h-10 flex flex-shrink-0 justify-center items-center mr-3 ${bgColor}`}>
            <Image src={notification.icon} alt="icon" width={16} height={16} />
        </div>

        <div className="flex flex-wrap">
            <span className="text-xs mr-1" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notification.message) }}></span>
            <span className="text-xs text-[var(--Neutrals-Gray-3)]">{formatDistanceToNow(notification.timestamp == null ? new Date() : notification.timestamp)} ago</span>

        </div>

    </div>;
}

